var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"emit-click-on-touch",rawName:"v-emit-click-on-touch"}],ref:"rootEl",attrs:{"role":_vm.disable ? 'presentation' : 'button'},on:{"click":_setup.showCommentsPanel}},[_c('div',{class:[
      'flex',
      {
        'items-end': !_setup.isUsedInPostExpandedView,
        'items-center': _setup.isUsedInPostExpandedView,
      },
      {
        'text-dark-text-200': _vm.colorScheme === 'light',
        'text-light-text-200': _vm.colorScheme === 'dark',
      },
    ]},[_c(_setup.OzIcon,{attrs:{"name":"comment_outline","size":_setup.iconSize}}),_vm._v(" "),_c('span',{class:[
        {
          'ms-0.5': !_setup.isUsedInPostExpandedView,
          'ms-1': _setup.isUsedInPostExpandedView,
        },
        {
          'text-12-16 font-sans': !_setup.isUsedInPostExpandedView,
          'text-body-small': _setup.isUsedInPostExpandedView,
        },
        {
          'text-dark-text-200': _vm.colorScheme === 'light',
          'text-light-text-200': _vm.colorScheme === 'dark',
        },
      ]},[_vm._v(_vm._s(_setup.commentsListLength))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }